import * as React from 'react';

import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import { EMainMenuCounters, EStore } from '@enums';

import { counters } from '@utils';

import { AppsStore, CurrentUserStore, MainMenuAppsStore, UiStore } from '@stores';

import { Api } from '@api';

import { getConfig } from '@base/constants';

import { usePreventScroll, useTouchMenu } from './hooks';
import { MainMenuTwaView, MainMenuView } from './MainMenuView';

import s from './MainMenu.scss';

export interface IMainMenuProps {
	className?: string;
	currentUserStore?: CurrentUserStore;
	mainMenuAppsStore?: MainMenuAppsStore;
	appsPopularStore?: AppsStore;
	uiStore?: UiStore;
}

export const MainMenu: React.FC<IMainMenuProps> = inject(
	EStore.UI,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
	EStore.APPS_POPULAR,
)(observer((
	{
		currentUserStore,
		mainMenuAppsStore: { myApps, suggestApps },
		uiStore,
		appsPopularStore,
		uiStore: {
			slidingMenu: { isVisible: slidingMenuIsVisible = false },
		},
	}: IMainMenuProps,
) => {
	const mainMenuViewRef = React.useRef<HTMLDivElement>(null);
	// const guestPopularAppsNumber = getConfig().isTwa ? 5 : 3;
	// const guestPopularApps: IMainMenuApp[] = appsPopularStore?.data?.apps?.slice(0, guestPopularAppsNumber)
	// 	.map((el) => ({
	// 		id: el.id,
	// 		title: el.titleShort,
	// 		icon: el.pics?.ico,
	// 		url: el.url,
	// 	}));

	const hideMenu = function() {
		uiStore.toggleSlideMenu(false);
	};

	const onLogin = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.preventDefault();

		counters.sendRB(EMainMenuCounters.LOGIN);
		Api.currentUser.logIn();
	};

	const onRegistration = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.preventDefault();

		counters.sendRB(EMainMenuCounters.REGISTRATION);
		Api.currentUser.registration();
	};

	const onLogout = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.preventDefault();

		currentUserStore.logout();
		counters.sendRB(EMainMenuCounters.LOGOUT);
		Api.currentUser.logout();
	};

	useTouchMenu({
		mainMenuViewRef,
		hideMenu,
	});

	usePreventScroll({ isDisableScroll: slidingMenuIsVisible });

	const props = {
		mainMenuViewRef: mainMenuViewRef,
		isVisible: slidingMenuIsVisible,
		currentUser: currentUserStore.currentUser,
		// menuApps: { myApps, suggestApps: suggestApps.length? suggestApps : guestPopularApps },
		menuApps: { myApps, suggestApps },
		onHide: hideMenu,
		onLogOutClick: onLogout,
		onLogInClick: onLogin,
		onRegistrationClick: onRegistration,
	};

	return (
		<div>
			{!getConfig().isTwa
				? <MainMenuView {...props}/>
				: <MainMenuTwaView {...props}/>
			}

			<div className={classNames(s.overlay, { [s.visible]: slidingMenuIsVisible })}
				onClick={hideMenu}
			/>
		</div>
	);
}));
